import { render, staticRenderFns } from "./FormTerapiaNutricional.vue?vue&type=template&id=7f8b8869"
import script from "./FormTerapiaNutricional.vue?vue&type=script&lang=js"
export * from "./FormTerapiaNutricional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports